import React, { Component } from 'react'
import {
  Block,
  Header,
  Body,
  Photo,
  List,
  ListItem,
  StyledLink
} from './styles'

import theme from '../../theme'
import elizabethcircle from '../../assets/elizabethcircle.png'

import SideBar from '../../components/SideBar'
import ProjectsCarousel from './components/ProjectsCarousel'

class CS extends Component {
  home = { link: '/', title: 'Home' }

  links = {
    main: [
      {
        title: 'CS',
        links: [
          { link: '#about', title: 'About' },
          {
            link: '#projects',
            title: 'Projects'
          }
        ]
      }
    ],
    other: [
      {
        title: 'Music',
        links: [
          { link: '/music#about', title: 'About' },
          {
            link: '/music#media',
            title: 'Media'
          }
        ]
      }
    ]
  }

  render() {
    return (
      <SideBar home={this.home} links={this.links}>
        <Block alignItems="center" color={theme.colors.palePurple} id="about">
          <Photo
            src={elizabethcircle}
            alt=""
            min-height="200px"
            min-width="200px"
            height="200px"
            width="200px"
            pt="20px"
            pb="20px"
          />
          <Header color={theme.colors.white}>About Me</Header>
          <Body color={theme.colors.white}>
            <List>
            <ListItem>
                Teaching Fellow of Harvard CS171 Data Visualization Course (2020)
              </ListItem>
              <ListItem>
                Harpist, "Musae" Board Member, and Webmaster of the{' '}
                <StyledLink
                  color={theme.colors.white}
                  hoverColor={theme.colors.purple}
                  href="https://www.harvardradcliffeorchestra.org/"
                >
                  Harvard-Radcliffe Orchestra
                </StyledLink> (2016-2020)
              </ListItem>
              <ListItem>
                Member of the{' '}
                <StyledLink
                  color={theme.colors.white}
                  hoverColor={theme.colors.purple}
                  href="https://www.hcs.harvard.edu/"
                >
                  Harvard Computer Society
                </StyledLink> (2016-2020)
              </ListItem>
              <ListItem>
                Public Service Announcements Director and DJ on 95.3FM Cambridge
                as part of the Classical department of{' '}
                <StyledLink
                  color={theme.colors.white}
                  hoverColor={theme.colors.purple}
                  href="https://www.whrb.org/"
                >
                  WHRB
                </StyledLink> (2016-2020)
              </ListItem>
              <ListItem>
                Dual-degree harp student at the New England Conservatory
              </ListItem>
              <ListItem>
                Avid poké eater (and maker ☺) and bubble tea drinker
              </ListItem>
            </List>
          </Body>
        </Block>
        <Block alignItems="center" color={theme.colors.white} id="projects">
          <Header color={theme.colors.palePurple}>Projects</Header>
          <ProjectsCarousel />
        </Block>
      </SideBar>
    )
  }
}

export default CS



// WEBPACK FOOTER //
// ./src/containers/CS/index.js